<template>
  <div>
    <Loader
      v-if="loaderEnabled"
      name="EditTransferStoreForm"
      v-bind:logo="loaderLogo"
    ></Loader>
    <KTCodePreview v-bind:title="'Cập nhật phiếu chuyển cửa hàng'">
      <template v-slot:preview>
        <div
          v-if="onLoading"
          class="d-flex justify-content-center align-items-center"
          style="min-height: 500px"
        >
          <b-spinner variant="primary" label="Loading..."></b-spinner>
        </div>
        <div v-else>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5"> Tên, Mã NV: </label>
                <b-form-input
                  size="sm"
                  v-model="mainModel.employeeName"
                  placeholder="Tên nhân viên"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5"> Cửa hàng hiện tại: </label>
                <b-form-input
                  size="sm"
                  v-model="mainModel.currentStoreName"
                  placeholder="Cửa hàng hiện tại"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5"> Cửa hàng muốn chuyển đến: </label>
                <b-form-input
                  size="sm"
                  v-model="mainModel.targetStoreName"
                  placeholder="Cửa hàng muốn chuyển đến"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5"> Thông tin tạo yêu cầu: </label>
                <b-form-input
                  size="sm"
                  v-model="getCreator"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5"> Thông tin cập nhật yêu cầu: </label>
                <b-form-input
                  size="sm"
                  v-model="getApprover"
                  disabled
                ></b-form-input>
              </b-form-group>
            </b-col>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5"> Ghi chú: </label>
                <b-form-textarea
                  id="textarea"
                  size="sm"
                  v-model="mainModel.description"
                  placeholder="Lý do chuyển cửa hàng"
                  rows="3"
                  max-rows="6"
                  disabled
                ></b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row>
            <b-col md="3">
              <b-form-group>
                <label class="mt-5">Trạng thái yêu cầu: </label>
                <span class="ml-4"
                  ><StatusForm :status="mainModel.status"
                /></span>
              </b-form-group>
            </b-col>
          </b-row>

          <b-row class="d-flex justify-content-between ml-0">
            <div>
              <b-button variant="primary" size="sm" @click="$router.go(-1)"
                >Quay lại</b-button
              >
            </div>
            <div v-if="checkPermissionUpdate()">
              <b-button variant="success" size="sm" v-b-modal.modal-approve
                >Duyệt</b-button
              >
              <b-button
                class="ml-2"
                variant="primary"
                size="sm"
                v-b-modal.modal-approve
                >Duyệt và chuyển</b-button
              >
              <b-button
                variant="warning"
                size="sm"
                class="ml-2"
                v-b-modal.modal-reject
                >Từ chối</b-button
              >
              <b-button
                variant="danger"
                size="sm"
                class="ml-2"
                v-b-modal.modal-delete
                >Xoá đơn</b-button
              >
            </div>
          </b-row>
        </div>
      </template>
    </KTCodePreview>
    <b-modal
      ref="modal-approve"
      id="modal-approve"
      title="Bạn có đồng ý duyệt đơn không?"
      hide-footer
    >
      <div>
        <p>
          <span style="font-weight: 500">Họ tên nhân viên:</span>
          {{ mainModel.employeeName }}
          {{ mainModel.employeeCode ? `(${mainModel.employeeCode})` : '' }}
        </p>
        <p>
          <span style="font-weight: 500">Cửa hàng hiện tại:</span>
          {{ mainModel.currentStoreName }}
        </p>
        <p>
          <span style="font-weight: 500">Cửa hàng yêu cầu chuyển đến:</span>
          {{ mainModel.targetStoreName }}
        </p>
      </div>
      <div class="d-flex justify-content-start">
        <b-button @click="hideModalApprove" variant="primary" size="sm"
          >Quay lại</b-button
        >
        <b-button
          @click="onHandleApprove"
          variant="success"
          class="ml-3"
          size="sm"
          >Tiến hành duyệt</b-button
        >
      </div>
    </b-modal>

    <b-modal
      ref="modal-reject"
      id="modal-reject"
      title="Bạn có đồng ý từ chối yêu cầu không?"
      hide-footer
    >
      <p>
        <span style="font-weight: 500">Họ tên nhân viên:</span>
        {{ mainModel.employeeName }}
        {{ mainModel.employeeCode ? `(${mainModel.employeeCode})` : '' }}
      </p>
      <p>
        <span style="font-weight: 500">Cửa hàng hiện tại:</span>
        {{ mainModel.currentStoreName }}
      </p>
      <p>
        <span style="font-weight: 500">Cửa hàng yêu cầu chuyển đến:</span>
        {{ mainModel.targetStoreName }}
      </p>
      <div class="d-flex justify-content-start">
        <b-button @click="hideModalReject" variant="primary" size="sm"
          >Quay lại</b-button
        >
        <b-button
          @click="onHandleReject"
          variant="warning"
          class="ml-3"
          size="sm"
          >Tiến hành từ chối</b-button
        >
      </div>
    </b-modal>
    <b-modal
      ref="modal-delete"
      id="modal-delete"
      title="Bạn có đồng ý từ chối yêu cầu không?"
      hide-footer
    >
      <p>
        <span style="font-weight: 500">Họ tên nhân viên:</span>
        {{ mainModel.employeeName }}
        {{ mainModel.employeeCode ? `(${mainModel.employeeCode})` : '' }}
      </p>
      <p>
        <span style="font-weight: 500">Cửa hàng hiện tại:</span>
        {{ mainModel.currentStoreName }}
      </p>
      <p>
        <span style="font-weight: 500">Cửa hàng yêu cầu chuyển đến:</span>
        {{ mainModel.targetStoreName }}
      </p>
      <div class="d-flex justify-content-start">
        <b-button @click="hideModalDelete" variant="primary" size="sm"
          >Quay lại</b-button
        >
        <b-button
          @click="onHandleDelete"
          variant="danger"
          class="ml-3"
          size="sm"
          >Tiến hành xoá đơn</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import ApiService from '@/core/services/api.service';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import {
  getEmployeeFromLocal,
  makeToastFaile,
  makeToastSuccess,
} from '@/utils/common';
import { JOB_TITLE, TRANSFER_STORE_FORM_STATUS } from '@/utils/enum';
import { checkPermission } from '@/utils/saveDataToLocal';
import StatusForm from '@/view/components/transfer-store-form/StatusForm.vue';
import KTCodePreview from '@/view/content/CodePreview.vue';
import Loader from '@/view/content/Loader.vue';
import { mapGetters } from 'vuex';
import { convertToDateSlash } from '@/utils/date';
import permissionMixin from '@/view/mixins/permission.mixin';

export default {
  mixins: [permissionMixin],
  data() {
    return {
      mainModel: {
        employeeName: '',
        employeeCode: '',
        currentStoreName: '',
        currentStoreId: null,
        targetStoreName: '',
        targetStoreId: null,
        status: 1,
        description: '',
      },
      createdAt: '',
      approvedAt: '',
      createdByName: '',
      approvedBy: '',
      approvedByName: '',
      formId: this.$route.query.id,
      statusEnum: TRANSFER_STORE_FORM_STATUS,
      permission: {
        edit: 'TRANSFER_STORE_FORM_UPDATE',
      },
      approvedJobTileId: [],
      onLoading: false,
    };
  },
  components: { KTCodePreview, StatusForm, Loader },

  created() {
    this.fetchTransferStoreById();
    this.userInfo = getEmployeeFromLocal();
  },
  mounted() {
    const isProfileRoute = this.$route.path.startsWith(
      '/profile/transfer-store-forms',
    );
    const breadcrumbRoute = isProfileRoute
      ? '/profile/transfer-store-forms'
      : '/transfer-store-forms';

    this.$store.dispatch(SET_BREADCRUMB, [
      {
        title: 'Phiếu yêu cầu chuyển cửa hàng',
        route: breadcrumbRoute,
      },
      { title: 'Cập nhật' },
    ]);
    this.formId = this.$route.query.id;
  },
  methods: {
    hideModalApprove() {
      this.$refs['modal-approve'].hide();
    },
    hideModalReject() {
      this.$refs['modal-reject'].hide();
    },
    hideModalDelete() {
      this.$refs['modal-delete'].hide();
    },
    fetchTransferStoreById() {
      this.onLoading = true;
      ApiService.get(`v1/transfer-store-forms/${this.formId}`)
        .then((res) => {
          const { data } = res.data;
          this.mainModel.employeeName = data.employeeName;
          this.mainModel.employeeCode = data.employeeCode;
          this.mainModel.currentStoreName = data.currentStoreName;
          this.mainModel.currentStoreId = data.currentStoreId;
          this.mainModel.targetStoreName = data.targetStoreName;
          this.mainModel.targetStoreId = data.targetStoreId;
          this.mainModel.status = data.status;
          this.mainModel.description = data.description;
          this.createdAt = data.createdAt;
          this.approvedAt = data.approvedAt;
          this.createdByName = data.createdByName;
          this.approvedBy = data.approvedBy;
          this.approvedByName = data.approvedByName;
          this.approvedJobTileId = data.approvedJobTileId;
        })
        .catch((err) => makeToastFaile(err.message))
        .finally(() => (this.onLoading = false));
    },
    onHandleApprove() {
      const reqData = {
        status: this.statusEnum.APPROVED,
      };
      ApiService.update('v1/transfer-store-forms', this.formId, reqData)
        .then((res) => {
          makeToastSuccess(res.data.message);
          this.fetchTransferStoreById();
        })
        .catch((err) => {
          makeToastFaile(err.response.data.message);
        })
        .finally(() => this.$refs['modal-approve'].hide());
    },
    onHandleReject() {
      const reqData = {
        status: this.statusEnum.REJECTED,
      };
      ApiService.update('v1/transfer-store-forms', this.formId, reqData)
        .then((res) => {
          makeToastSuccess(res.data.message);
          this.fetchTransferStoreById();
        })
        .catch((err) => {
          makeToastFaile(err.response.data.message);
        })
        .finally(() => this.$refs['modal-reject'].hide());
    },
    onHandleDelete() {
      ApiService.delete(`v1/transfer-store-forms/${this.formId}`)
        .then((res) => {
          makeToastSuccess(res.data.message);
        })
        .catch((err) => {
          makeToastFaile(err.response.data.message);
        })
        .finally(() => {
          this.$refs['modal-delete'].hide();
          this.$router.go(-1);
        });
    },

    checkPermissionUpdate() {
      if (this.userInfo.jobTitleId === JOB_TITLE.GD) return true;
      if (this.approvedJobTileId.includes(this.userInfo.jobTitleId))
        return true;
      return false;
    },
  },
  computed: {
    ...mapGetters(['breadcrumbs', 'pageTitle', 'layoutConfig']),
    loaderEnabled() {
      return !/false/.test(this.layoutConfig('loader.type'));
    },
    loaderLogo() {
      return process.env.BASE_URL + this.layoutConfig('loader.logo');
    },
    dateRangeText() {
      return this.dates.join(' ~ ');
    },
    getCreator() {
      return `${this.createdByName} - ${convertToDateSlash(this.createdAt)}`;
    },
    getApprover() {
      if (!this.approvedBy) return '';
      return `${this.approvedByName} - ${convertToDateSlash(this.approvedAt)}`;
    },
    checkAllowEdit() {
      return checkPermission(this.permission.edit);
    },
  },
};
</script>

<style>
#modal-approve {
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
}

.modal-dialog {
  transform: none;
  display: flex;
  justify-content: center !important;
  align-items: center !important;
}
</style>
